<template>
  <div class="pa-0 ma-0">
    <LoginForm mode="register" :response="message" v-on:form-submitted="register">
      <template v-slot:details>
        <div class="text-center pb-4">
          <v-btn
            text
            small
            color="primary"
            elevation="0"
            class="text-none mb-0 pb-0 ml-n3"
            @click="toggleLicenseTransfer"
          >Are you a v1.7 user?</v-btn>
        </div>

        <v-dialog flat outlined v-model="showLicenseTransfer" max-width="600">
          <v-card flat class="ma-0 pa-4">
            <v-card-title class="pb-6 justify-center">Activate Your License</v-card-title>
            If you have a current license for v1.7 of Beyond Labz your license can activate this
            version as well. Before proceeding further, start v1.7, go to the License tab, copy the
            license number, and then quit v1.7. Both versions cannot run at the same time. When you
            get to the License Manager in the v2.0 during setup, you can enter your v1.7 license in
            the Activation Code box.
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:buttons>
        <v-btn text color="primary" class="text-none" to="/login">Login</v-btn>
        <v-btn text color="primary" class="text-none" to="/reset_password">Reset Password</v-btn>
      </template>
    </LoginForm>
    <v-dialog v-model="dialog" persistent max-width="480">
      <v-card>
        <v-card-title class="headline">Account Registered</v-card-title>
        <v-card-text>Congratulations, your account has been successfully created.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text to="/login">Login</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LoginForm from '@/components/LoginForm.vue';

export default {
  name: 'Register',
  components: { LoginForm },
  data: () => ({
    dialog: false,
    showLicenseTransfer: false,
    message: {
      content: '',
      color: 'black',
    },
  }),
  computed: {
    modeTitle() {
      return this.modeOptions[this.mode] || '';
    },
  },
  methods: {
    toggleLicenseTransfer() {
      this.showLicenseTransfer = !this.showLicenseTransfer;
    },
    register(data) {
      const url = 'https://portal.beyondlabz.com/auth/register';
      this.$http
        .post(url, data)
        .then((resp) => {
          if (resp.status === 200) {
            let success = false;
            if (typeof resp.data !== 'undefined' && resp.data.login === 1) {
              success = true;
            }
            if (success) {
              this.dialog = true;
            } else {
              this.message.content = 'Failed to register. The most likely cause is a duplicate email. Please try again or contact support@beyondlabz.com.';
              this.message.color = 'red';
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
</style>
